module.exports = __webpack_public_path__ + "img/take_photo.7f4a3909.png";